import moment from 'moment';

// Check if any deadline has passed for the user task
export function checkDeadlinePassed(reminderAt) {
  const currentDate = moment();
  const reminderMoment = moment(reminderAt);

  return currentDate.isAfter(reminderMoment);
}
